import './index.scss';

import imgcredito2 from '../../../../../assets/images/para-sua-empresa/img-credito/img-credito2@2x.png';

export const ACE = () => {

    return (
        <div className='container-select-credit'>
            <div className='cont-dados-1'>
                <h1> ACE - Adiantamento sobre cambiais entregues </h1>

                <p>
                    Adiantamento sobre cambiais entregues refere-se a uma operação
                    financeira em que uma empresa recebe um adiantamento de recursos
                    de uma instituição financeira (geralmente um banco) utilizando
                    cambiais (letras de câmbio, cheques, notas promissórias, etc.) de seus
                    clientes como garantia. Em outras palavras, a empresa "antecipa" o
                    recebimento dos valores representados pelas cambiais, obtendo liquidez
                    imediata. Veja como funciona:
                </p>

                <p>
                    <span style={{ fontWeight: 'bold' }}> 1. Cambiais como garantia: </span>
                    A empresa entrega as cambiais de seus
                    clientes para o banco.
                </p>

                <p>
                    <span style={{ fontWeight: 'bold' }}> 2. Análise de crédito: </span>
                    O banco avalia o risco da operação, considerando
                    a qualidade das cambiais (emissor, prazo, etc.) e o histórico de crédito da
                    empresa.
                </p>

                <p>
                    <span style={{ fontWeight: 'bold' }}> 3. Adiantamento dos recursos: </span>
                    Após a aprovação, o banco adianta os
                    recursos para a empresa, descontando um percentual referente a juros,
                    taxas e outros encargos.
                </p>

                <p>
                    <span style={{ fontWeight: 'bold' }}>  4. Recebimento das cambiais: </span>
                    Na data de vencimento das cambiais,
                    o banco as apresenta para pagamento aos respectivos emissores (clientes
                    da empresa).
                </p>

                <p>
                    <span style={{ fontWeight: 'bold' }}> 5. Quitação da operação: </span>
                    Com o recebimento dos valores das cambiais,
                    a operação de adiantamento é liquidada
                </p>

            </div>
            <div className='cont-dados-2'>
                <img alt={imgcredito2} src={imgcredito2} />
                <div>
                    <h1> Vantagens </h1>

                    <p>
                        <span style={{ fontWeight: 'bold' }}>Melhora o fluxo de caixa: </span>
                        Permite à empresa receber
                        recursos antes do vencimento das cambiais,
                        melhorando seu capital de giro.
                    </p>

                    <p>
                        <span style={{ fontWeight: 'bold' }}>Flexibilidade: </span>
                        Oferece uma alternativa para empresas
                        que precisam de recursos imediatos e possuem
                        cambiais como forma de recebimento.
                    </p>

                    <p>
                        <span style={{ fontWeight: 'bold' }}>Redução da inadimplência: </span>
                        Ao antecipar os recebíveis,
                        a empresa reduz o risco de inadimplência de seus
                        clientes.
                    </p>

                    <div className='buttons-style inv' style={{marginTop:"10px"}}>
                    <a href='https://wa.me/5511973667387' target="_blank" rel="noopener noreferrer" > Fale com um especialista </a>
                </div>
                </div>
            </div>
        </div>

    )
}

